// Components/PaymentModal/PaymentStatusModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './PaymentStatusModal.css';

const PaymentStatusModal = ({ status, loading, message, onClose }) => {
  const statusConfig = {
    success: {
      icon: '✓',
      color: '#4CAF50',
      title: 'Payment Successful',
      buttonText: 'View Orders'
    },
    failure: {
      icon: '✗',
      color: '#F44336',
      title: 'Payment Failed',
      buttonText: 'Try Again'
    },
    processing: {
      icon: '⏳',
      color: '#FFC107',
      title: 'Processing Payment',
      buttonText: 'Cancel'
    }
  };

  const currentStatus = statusConfig[status] || statusConfig.processing;

  const handleButtonClick = () => {
    if (status === 'processing' && !loading) {
      // Option: annuler et retourner au panier
      toast.info('Payment check cancelled');
    }
    onClose();
  };

  return (
    <div className="payment-status-overlay">
      <div className="payment-status-modal" style={{ borderColor: currentStatus.color }}>
        <div 
          className="status-icon" 
          style={{ backgroundColor: currentStatus.color }}
        >
          {currentStatus.icon}
        </div>
        
        <h2>{loading ? 'Processing...' : currentStatus.title}</h2>
        <p>{message}</p>
        
        {loading && (
          <div className="loading-indicator">
            <div className="loading-spinner" style={{ borderColor: currentStatus.color }}></div>
            <p className="loading-text">Please wait...</p>
          </div>
        )}
        
        {!loading && (
          <button 
            className="status-button" 
            style={{ backgroundColor: currentStatus.color }}
            onClick={handleButtonClick}
          >
            {currentStatus.buttonText}
          </button>
        )}
        
        {status === 'failure' && !loading && (
          <div className="failure-help">
            <p className="help-title">Need help?</p>
            <ul className="help-list">
              <li>• Check your payment method details</li>
              <li>• Ensure you have sufficient funds</li>
              <li>• Contact support if the issue persists</li>
            </ul>
          </div>
        )}
        
        <ToastContainer 
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  );
};

PaymentStatusModal.propTypes = {
  status: PropTypes.oneOf(['success', 'failure', 'processing']).isRequired,
  loading: PropTypes.bool,
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

PaymentStatusModal.defaultProps = {
  loading: false,
  message: ''
};

export default PaymentStatusModal;